/*
🌙 Premium Theme Provider
Professional theme management for GetMyHive Safety Intelligence System
*/

import React from 'react';
import { ConfigProvider } from 'antd';
import trTR from 'antd/locale/tr_TR';
import { ThemeContext, useThemeState } from '../../hooks/useTheme';

interface ThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const themeState = useThemeState();

  // Update document classes and meta for smooth theme switching
  React.useEffect(() => {
    const root = document.documentElement;
    
    // Apply theme classes
    if (themeState.isDarkMode) {
      root.classList.add('dark-theme');
      root.classList.remove('light-theme');
    } else {
      root.classList.add('light-theme');
      root.classList.remove('dark-theme');
    }
    
    // Update browser theme-color for mobile
    const themeColorMeta = document.querySelector('meta[name="theme-color"]');
    if (themeColorMeta) {
      themeColorMeta.setAttribute(
        'content', 
        themeState.isDarkMode ? '#13171c' : '#ffffff'
      );
    }
    
    // Update CSS custom properties for immediate effect
    root.style.setProperty(
      '--theme-bg-primary', 
      themeState.isDarkMode ? '#13171c' : '#f8fafc'
    );
    root.style.setProperty(
      '--theme-bg-container', 
      themeState.isDarkMode ? '#1a1d23' : '#ffffff'
    );
    root.style.setProperty(
      '--theme-text-primary', 
      themeState.isDarkMode ? '#f7f7f7' : '#111827'
    );
    
  }, [themeState.isDarkMode]);

  return (
    <ThemeContext.Provider value={themeState}>
      <ConfigProvider 
        theme={themeState.antdTheme}
        locale={trTR}
      >
        {children}
      </ConfigProvider>
    </ThemeContext.Provider>
  );
};
